module.exports = __webpack_public_path__ + "img/jk_icon_gongzuoshigongchengjikeclick.5c925580.png";